// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__VHVaV","title":"Projects_title__BiYoI","wrapper":"Projects_wrapper__C06Db","project":"Projects_project__MYuG+"};